require('../../modules/es6.reflect.get-own-property-descriptor');
module.exports = require('../../modules/_core').Reflect.getOwnPropertyDescriptor;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/fn/reflect/get-own-property-descriptor.js
// module id = BX1Y
// module chunks = 3